module.exports = __webpack_public_path__ + "static/csi_dataviz-04b855d32a8819c8af6ce4985b318e21.png";